import { useState } from 'react';
import TabSelector from 'modules/common/components/TabSelector';
import PharmaciesProvidersContainer from 'modules/categories/pharmacies/container/PharmaciesProvidersContainer';
import { PageTabs, PageTabsOptions } from './helper';
import { Container, Wrapper } from './style';
import PharmaciesProductsContainer from './PharmaciesProductsContainer';

const PharmaciesAndProductsContainerSelector = () => {
  const [selectedTabOption, setSelectedTabOption] = useState(PageTabs.Pharmacies);

  return (
    <Container>
      <Wrapper>
        <TabSelector
          onChange={payload => {
            setSelectedTabOption(payload.value);
          }}
          options={PageTabsOptions}
          value={selectedTabOption}
        />
        {selectedTabOption === PageTabs.Pharmacies && <PharmaciesProvidersContainer />}
        {selectedTabOption === PageTabs.Products && <PharmaciesProductsContainer />}
      </Wrapper>
    </Container>
  );
};

PharmaciesAndProductsContainerSelector.propTypes = {};

PharmaciesAndProductsContainerSelector.defaultProps = {};

export default PharmaciesAndProductsContainerSelector;
